import { dimensions, dimensionTraits } from './dimensions'
import { questions, dimensionWeights, questionCategories } from './questions'
import { types, typeRelations } from './types'
import { careerCategories } from './careers'
import { personalizedLearning, learningStyles } from './learning'
import { growthSuggestions, developmentPaths } from './growth'
import { analysis } from './analysis'

export const MBTI = {
  dimensions,
  dimensionTraits,
  questions,
  dimensionWeights,
  questionCategories,
  types,
  typeRelations,
  careerCategories,
  personalizedLearning,
  learningStyles,
  growthSuggestions,
  developmentPaths,
  analysis
}

export default MBTI 